/**
 * The design-board marketing pages, by internal (prefix-rewritten) path.
 *
 * These five routes render a frozen clawinstall-public design component with its
 * own bottom-left `CookieBanner`, so the global {@link CookieConsentBanner}
 * must NOT also render there — the root layout gates on {@link isPublicPagePath}.
 *
 * @since 1.0.0
 */
export const PUBLIC_PAGE_PATHS: ReadonlySet<string> = new Set([
  "/clawinstall",
  "/clawinstall/pricing",
  "/clawinstall/compare",
  "/clawinstall/faq",
  "/clawinstall/security",
]);

/**
 * Whether `pathname` is one of the design-board marketing pages (trailing slash
 * tolerated; `/` is the FlirtMachine root, never a public page).
 *
 * @since 1.0.0
 */
export const isPublicPagePath = (pathname: string): boolean =>
  PUBLIC_PAGE_PATHS.has(pathname === "/" ? "/" : pathname.replace(/\/$/, ""));
